export enum AttributeType {
    LINK,
    COMMENT,
    ASSUMPTION
}
